import { Box, Heading,Image, Select, Text } from '@chakra-ui/react'
import React from 'react'
import styles from '../Styles/Footer.module.css'
import FooterLinkComponent from './FooterLinkComponent'
import {FaFacebook,FaTwitter} from 'react-icons/fa'
import {BsArrowRight,BsLinkedin,BsYoutube,BsPinterest,BsInstagram} from 'react-icons/bs'
function Footer({related_links}) {
 
 const products=[
  {
    to:'/',
    title:'Why Mailchimp?'
  },
  {
    to:'/',
    title:'Product Updates'
  },
  {
    to:'/',
    title:'Email Marketing'
  },
  {
    to:'/',
    title:'Websites'
  },
  {
    to:'/',
    title:'Transactional Email'
  },
  {
    to:'/',
    title:'How We Compare'
  },
  {
    to:'/',
    title:'GDPR Complaines'
  },
  {
    to:'/',
    title:'Security'
  },
  {
    to:'/',
    title:'Status'
  },
  {
    to:'/',
    title:'Mobile App'
  }
  
 ]
 const Resources=[
  {
    to:'/',
    title:'Marketing Library'
  },
  {
    to:'/',
    title:'Free Marketing Tools'
  },
  {
    to:'/',
    title:'Marketing Glossary'
  },
  {
    to:'/',
    title:'Integration Directory'
  }
 ]
 const Community=[
  {
    to:'/',
    title:'Agencies & Freelancers'
  },
  {
    to:'/',
    title:'Developers'
  },
  {
    to:'/',
    title:'Events'
  }
 ]
 const Company=[
  {
    to:'/',
    title:'Our Story'
  },
  {
    to:'/',
    title:'Newsroom'
  },
  {
    to:'/',
    title:'Annual Report'
  },
  {
    to:'/',
    title:'Careers'
  },
  {
    to:'/',
    title:'Accessibility'
  }
 ]
 const Help=[
  {
    to:'/',
    title:'Contact Us'
  },
  {
    to:'/',
    title:'Hire an Expert'
  },
  {
    to:'/',
    title:'Help Center'
  },
  {
    to:'/',
    title:'Talk to Sales'
  },
 ]

  return (
    <div >
      <Box backgroundColor="#efeeea" >
        <Box className={styles.related_div}>
          <Heading as="h4" size="sm">Related Links: </Heading>
          <FooterLinkComponent data={related_links}/>
        </Box>
        <br/>
        <hr />
        <Box borderTop="1px solid grey"  borderBottom="1px solid grey" padding="40px 0px" className={styles.footer_main_div}>
          <Box>
              <Heading as="h4" display="flex" justifyContent="left" size="md">Products</Heading>
              <br />
              <FooterLinkComponent data={products}/>
          </Box>
          <Box>
            <Heading as="h4" display="flex" justifyContent="left" size="md">Resources</Heading>
              <br />
              <FooterLinkComponent data={Resources}/>
          </Box>
          <Box>
            <Heading as="h4" display="flex" justifyContent="left" size="md">Community</Heading>
              <br />
              <FooterLinkComponent data={Community}/>
          </Box>
          <Box>
              <Heading as="h4" display="flex" justifyContent="left" size="md">Company</Heading>
              <br />
              <FooterLinkComponent data={Company}/>
          </Box>
          <Box>
              <Heading as="h4" display="flex" justifyContent="left" size="md">Help</Heading>
              <br />
              <FooterLinkComponent data={Help}/>
          </Box>
          <Box>
            <Box display="flex" alignItems="center" >
                <Image w="100px" mr="4px" src='https://logos-world.net/wp-content/uploads/2021/02/Mailchimp-Logo-2018-present.png' alt='Dan Abramov' />
                <Text>Presents</Text>
              </Box>
                <Text textAlign="left">Films, podcasts, and original<br/> series that celebrate the<br/> entrepreneurial spirit.</Text>
                <br />
              <Box display="flex" alignItems="center" >
                  <Heading mr="20px" textAlign="left" as="h5" size="sm">Check it Out</Heading>
                  <BsArrowRight fontSize="30px"/>
              </Box>
              <br />
              <Box>
                  <Image width="150px" alt="image" src="https://user-images.githubusercontent.com/99709824/179729907-77336999-d0d6-46bd-9e50-02757d1b8506.png"/>
                  <br/>
                  <Text textAlign="left">Expert insights, industry<br/> trends, and inspiring stories<br/> that help you live and work on<br/> your own terms.</Text>
                  <br/>
                  <Box display="flex" alignItems="center" >
                    <Heading mr="20px" textAlign="left" as="h5" size="sm">Learn More</Heading>
                  <BsArrowRight fontSize="30px"/>
              </Box>
              </Box>
          </Box>
        </Box>
        <Box p="4rem 0rem" display="flex" alignItems="center" justifyContent="center">
          <Box w="40%" h="100px" display="flex" alignContent="center" justifyContent="space-evenly" >
            <Image width="200px" h="100px" src="https://www.thejockeyclub.co.uk/contentassets/d35e76feefb8411ca3338c0f5036416e/app-store-logos-690.png"
              />
            <Box display="flex" w="45%" justifyContent="space-evenly" alignItems="center">
                <a href="https://www.facebook.com/mailchimp/"><FaFacebook fontSize="28px"/></a>
                <a href="https://twitter.com/Mailchimp"><FaTwitter fontSize="28px"/></a>
                <a href="https://www.instagram.com/mailchimp/"><BsLinkedin fontSize="28px"/></a>
                <a href="https://www.linkedin.com/company/intuitmailchimp/"><BsInstagram fontSize="28px"/></a>
                <a href="https://www.youtube.com/user/Mailchimp"><BsYoutube fontSize="28px"/></a>
                <a href="https://www.pinterest.com/mailchimp/"><BsPinterest fontSize="28px"/></a>
            </Box>
          </Box>
          <Box padding="40px">
            <Select placeholder='English'>
              <option value='option2'>Espanol</option>
              <option value='option3'>Francais</option>
              <option value='option3'>Portugues</option>
              <option value='option3'>Deutsch</option>
              <option value='option3'>Italiano</option>
            </Select>
            <Text fontSize="10px" textAlign="left" marginTop="10px">
              ©2001-2022 All Rights Reserved. Mailchimp® is a registered<br/>
               trademark of The Rocket Science Group. Apple and the <br/>
               Apple logo are trademarks of Apple Inc. Mac App Store is a <br/>
               service mark of Apple Inc. Google Play and the Google Play <br/>
               logo are trademarks of Google Inc. <Heading fontSize="10px" as="h5" size="sm">Privacy | Terms | Cookie<br/>
                Preferences</Heading></Text>
          </Box>
        </Box>
    </Box>
    </div>
  )
}

export default Footer